import { Delete } from "@mui/icons-material";
import { PopupMenuProps } from "../../../PopupMenu/PopupMenu";
import PopupMenu from "../../../PopupMenu/PopupMenu";

type TodoListTitlePopupMenuProps = {
    onDelete: () => void;
} & Omit<PopupMenuProps, 'options'>


const TodoListTitlePopupMenu = ({ onDelete, ...props }: TodoListTitlePopupMenuProps) => {
    return <PopupMenu options={[{ icon: <Delete sx={{ color: 'text.secondary' }} />, label: 'Delete', onClick: onDelete, labelColor: 'text.secondary' }]} {...props} />
}

export default TodoListTitlePopupMenu;  